import React from 'react';
import { Container, Grid, Paper } from '@mui/material';
import DashboardLayout from '../../shared/layout/DashboardLayout';
import OtrosTable from './components/OtrosTable';

export default function MainOtros() {
  return (
    <DashboardLayout>
      <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
              <OtrosTable />
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </DashboardLayout>
  );
}

export { default as ListCuestionarioTesisTorres } from './tesisTorres/ListCuestionarioTesisTorres';
